import React, { useCallback, useState, useEffect } from 'react';
import { get } from 'lodash';
import request from 'utils/request_ajax';
import RemoteAutoComplete from 'components/shared/RemoteAutoComplete';
import { Icon } from 'ui';
import Loadable from 'components/shared/loadable';
import { setQueryString } from 'utils/url';

const LessonExpertView = ({ currentExpert, expertPath, suggestionsPath }) => {
  const [expert, setExpert] = useState(() => get(currentExpert, '[0].owner'));
  const [loading, setLoading] = useState(false);

  async function handleExpertRemove() {
    // eslint-disable-next-line no-alert, no-restricted-globals
    if (confirm(t('expert.remove_confirmation', { name: expert.name }))) {
      try {
        setLoading(true);
        await request.delete(expertPath, { owner_id: expert.id });
        setExpert(null);
      } finally {
        setLoading(false);
      }
    }
  }

  async function handleExpertAdd(suggestion) {
    try {
      setLoading(true);
      await request.post(expertPath, { owner_id: suggestion.id });
      setExpert(suggestion);
    } finally {
      setLoading(false);
    }
  }

  const handleOwnerRemoved = useCallback(
    ownerId => {
      if (expert && expert.id === ownerId) {
        setExpert(null);
      }
    },
    [expert],
  );

  useEffect(
    () => pubsub.subscribe('lesson-owner-removed', handleOwnerRemoved),
    [handleOwnerRemoved],
  );

  return (
    <div>
      {expert && (
        <div className="quicklist-item">
          <Loadable loading={loading}>
            {expert.name}
            <button
              type="button"
              className="u-resetBtn quicklist-remove"
              onClick={handleExpertRemove}
              disabled={loading}
            >
              <Icon name="remove" />
            </button>
          </Loadable>
        </div>
      )}
      {!expert && (
        <RemoteAutoComplete
          className="SidebarModule-input"
          placeholder={t('ownership.share.placeholder')}
          getSuggestionValue={suggestion => suggestion.name}
          mapResponseToSuggestions={response => response.owners}
          onSuggestionSelected={handleExpertAdd}
          renderSuggestion={suggestion => suggestion.name}
          url={setQueryString(suggestionsPath, { limit: 10 }, { merge: true })}
          disabled={loading}
        />
      )}
    </div>
  );
};

// react-on-rails workaround to get hooks to work
export default props => <LessonExpertView {...props} />;
